import React from "react"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers"
import { ICON_CONSTANTS } from "../../../../constants/ImageConstants.js"
import clsx from "clsx"

export const EditSvgIcon = ({ size = "md" }) => {
  return (
    <span className={clsx(["svg-icon svg-icon-secondary", `svg-icon-${size}`])}>
      <SVG src={toAbsoluteUrl(ICON_CONSTANTS.EDIT_LIST)} />
    </span>
  )
}
